/**
 * Logo: oyunun adı zaten üç sayı. Rakamları üç karta yerleştirmek adı ve
 * kuralı aynı anda anlatıyor — 3 / 5 / 8 bu oyunda hedeflerin kendisi.
 * Soldaki kart en üstte: adın okunuşuyla aynı yönde.
 */
export function Logo({ small }: { small?: boolean }) {
  return (
    <span className={`logo ${small ? 'logo--small' : ''}`} aria-label="Üç Beş Sekiz">
      {[3, 5, 8].map((n, i) => (
        <b key={n} className={`logo__card logo__card--${n}`} style={{ zIndex: 3 - i }}>
          {n}
        </b>
      ))}
    </span>
  );
}
